import React from 'react'
import Careerimg from '../../assets/images/Careerimg.png'
import Careerbg from '../../assets/images/Careerbg.png'
import { Link } from 'react-router-dom'
import { Element } from 'react-scroll'

function Career() {
  return (
    <Element name='Careers'>
      <div className="py-5" style={{ background: '#f7f5fb' }}>
        <div className="container" style={{ maxWidth: 1100 }}>
          <div className="row align-items-center g-5">

            {/* ── Image column ── */}
            <div className="col-12 col-md-6 d-flex justify-content-center">
              <div style={{ position: 'relative', display: 'inline-block', width: '100%', maxWidth: 420 }}>
                <img
                  src={Careerbg}
                  alt=""
                  style={{ width: '100%', display: 'block', borderRadius: 24, opacity: 0.9 }}
                />
                <img
                  src={Careerimg}
                  alt="IT Staff Augmentation"
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '80%',
                    objectFit: 'contain',
                  }}
                />
              </div>
            </div>

            {/* ── Text column ── */}
            <div className="col-12 col-md-6">
              <p
                style={{
                  fontSize: '0.7rem',
                  fontWeight: 700,
                  letterSpacing: '0.14em',
                  textTransform: 'uppercase',
                  color: '#563D7C',
                  marginBottom: '0.75rem',
                }}
              >
                IT Staff Augmentation
              </p>

              <h2
                style={{
                  fontWeight: 800,
                  color: '#1a1a2e',
                  lineHeight: 1.2,
                  fontSize: 'clamp(1.6rem, 3vw, 2.2rem)',
                  marginBottom: '1.25rem',
                }}
              >
                IT Staff Augmentation
              </h2>

              <div
                style={{
                  width: 48, height: 3,
                  background: '#563D7C',
                  borderRadius: 2,
                  marginBottom: '1.5rem',
                  opacity: 0.5,
                }}
              />

              <p style={{ fontSize: '0.925rem', color: '#555', lineHeight: 1.85 }}>
                Are you looking to hire talented developers with a specific skill set that your
                company needs? The top IT staff augmentation company in India, AIS, provides a
                wide range of hiring options. To add devoted team members with years of experience
                and skill sets to fulfill the needs of your business, you can use expert IT staff
                augmentation services.
              </p>
            </div>

          </div>
        </div>
      </div>
    </Element>
  )
}

export default Career